import React, { useEffect, useRef } from "react";
import { StudentAd2Card } from "./ad2Card";
import { Col, Row } from "react-bootstrap";
import { Student, StudentCoachingProfileBoxTitle } from "../styles/Ad2Styles";
import ReactSpeedometer from "react-d3-speedometer";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import html2canvas from "html2canvas";
import { updateImageBase } from "./imageReducer";

export function Ad2EnglishProficiency({data, onViewMoreClick}) {
    const chartData = data;
    const status = data && chartData.status;
    const totalEnglishProficiencyLevel = chartData && chartData?.General?.points;
    const grammar = chartData && chartData?.General?.values?.Grammar?.points;
    const comprehension = chartData && chartData?.General?.values?.Comprehension?.points;
    const chartRef = useRef(null);
    const chartRef2 = useRef(null);
    const chartRef3 = useRef(null);
    const refList = [chartRef,chartRef2,chartRef3]    

    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();

     useEffect(() => {
                    console.log("englishProficiencyData", data);
        if (data && data?.General) {
          setTimeout(() => {
            refList.forEach((ref,index)=>{
                  html2canvas(ref.current, { backgroundColor: null, scale: 2 }).then((canvas) => {
  const ctx = canvas.getContext("2d");
  const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  let top = canvas.height, bottom = 0, left = canvas.width, right = 0;
  
  for (let y = 0; y < imgData.height; y++) {
    for (let x = 0; x < imgData.width; x++) {
      const alpha = imgData.data[(y * imgData.width + x) * 4 + 3];
      if (alpha > 0) {
        if (y < top) top = y;
        if (y > bottom) bottom = y;
        if (x < left) left = x;
        if (x > right) right = x;
      }
    }
  }

  const padding = 10; // small buffer so nothing gets clipped
  const cropX = Math.max(0, left - padding);
  const cropY = Math.max(0, top - padding);
  const cropW = Math.min(canvas.width, right + padding) - cropX;
  const cropH = Math.min(canvas.height, bottom + padding) - cropY;

  const trimmed = ctx.getImageData(cropX, cropY, cropW, cropH);
  const newCanvas = document.createElement("canvas");
  newCanvas.width = cropW;
  newCanvas.height = cropH;
  newCanvas.getContext("2d").putImageData(trimmed, 0, 0);

  const base64 = newCanvas.toDataURL("image/png");
  dispatch(updateImageBase({ name: `englishProficiency${index + 1}`, value: base64 }));
});
            })
               
          
          
          }, 500); // wait a bit for charts to render
        }
      }, [data]);
    return <>
        <StudentAd2Card title={t("English Proficiency")} status={status} onViewMoreClick={onViewMoreClick}>
           <div >
            <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                <Col md="4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                <div ref={chartRef}>
                    <Row style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Col xs="12" md="4" style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '30px 0px 30px 0px'
                        }}>
                            <ReactSpeedometer
                                // currentValueText={item.title}
                                height={170}
                                width={230}
                                minValue={0}
                                maxValue={1}
                                ringWidth={50} //thickness
                                // fluidWidth={true}
                                value={Math.round(totalEnglishProficiencyLevel) / 100} //parseInt(value) / 100
                                needleColor="#542F41"
                                segmentColors={["#058AA5","#00B4D8","#62DBF1","#90E0EF","#CAF0F8"]}
                                valueFormat=".0%"
                                needleHeightRatio={0.7}
                                customSegmentStops={[0, 0.5, 0.6, 0.75, 0.9, 1.0]}
                            />
                        </Col>
                        <Col xs="12">
                            <StudentCoachingProfileBoxTitle>
                                <span dangerouslySetInnerHTML={{__html: t(`Total English <br/> Proficiency Level`)}}></span>
                            </StudentCoachingProfileBoxTitle>
                        </Col>
                    </Row>
                </div>
                  
                </Col>
                <Col md="4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                <div ref={chartRef2}>
                     <Row style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Col xs="12" style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '30px 0px 30px 0px'
                        }}>
                            <ReactSpeedometer
                                // currentValueText={item.title}
                                height={170}
                                width={230}
                                minValue={0}
                                maxValue={1}
                                ringWidth={50} //thickness
                                value={Math.round(grammar) / 100} //parseInt(value) / 100
                                needleColor="#542F41"
                                segmentColors={["#73284D","#9B3668","#BE598B","#D24C8E","#FF75B9"]}
                                valueFormat=".0%"
                                needleHeightRatio={0.7}
                                customSegmentStops={[0, 0.5, 0.6, 0.75, 0.9, 1.0]}
                            />
                        </Col>
                        <Col xs="12">
                            <StudentCoachingProfileBoxTitle>
                                <span>{t("Grammar")}</span>
                            </StudentCoachingProfileBoxTitle>
                        </Col>
                    </Row>
                </div>
                   
                </Col>
                <Col md="4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                <div ref={chartRef3}>
                    <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <Col xs="12" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '30px 0px 30px 0px' }}>
                            <ReactSpeedometer
                                // currentValueText={item.title}
                                height={170}
                                width={230}
                                minValue={0}
                                maxValue={1}
                                ringWidth={50} //thickness
                                value={Math.round(comprehension) / 100} //parseInt(value) / 100
                                needleColor="#542F41"
                                segmentColors={["#0B2F4A","#053D67","#137BC9","#137BC9","#319FF2"]}
                                startColor="#"
                                endColor="#"
                                valueFormat=".0%"
                                needleHeightRatio={0.7}
                                customSegmentStops={[0, 0.5, 0.6, 0.75, 0.9, 1.0]}
                            />
                        </Col>
                        <Col xs="12">
                            <StudentCoachingProfileBoxTitle>
                                <span>{t("Comprehension")}</span>
                            </StudentCoachingProfileBoxTitle>
                        </Col>
                    </Row>
                </div>
                    
                </Col>
            </Row>
            </div> 
        </StudentAd2Card>
    </>;
}